import React from 'react';
import Color from '../../../components/Color/Color';
import Image from '../../../components/Image/Image';
import * as classes from '../Navigation.module.css';

const NavBox = (props) =>{
    const styles = props.active? [classes.NavBox, classes.Active] : [classes.NavBox]

    return (
        <div
            className={styles.join(' ')}
            onClick={props.clicked}
        >
            <Image imgsrc={props.image} className={classes.NavImage}/>
            <Color color={props.color} classes={[classes.Color]}/>
        </div>
    )
};

export default NavBox;